<template>
  <div class="c-adminEventEdit">
    <PageTitle titleText="イベント登録"></PageTitle>
    <el-col :span="24">
      <section>
        <!-- <h3 class="section-title">イベント</h3> -->

        <!-- <el-col :span="24"> -->
        <el-form
          ref="form_target"
          :model="doc"
          class="c-adminEventEdit__menu"
          :rules="docRules"
        >
          <el-form-item
            label="タイトル"
            prop="title"
            class="c-adminEventEdit__textAndForm"
          >
            <el-input type="text" placeholder="タイトル" v-model="doc.title">
            </el-input>
          </el-form-item>
          <el-form-item
            label="掲載期間"
            prop="publishRange"
            class="c-adminEventEdit__textAndForm"
          >
            <el-date-picker
              v-model="doc.publishRange"
              type="daterange"
              range-separator="〜"
              start-placeholder="掲載開始日"
              end-placeholder="掲載終了日"
            >
            </el-date-picker>
          </el-form-item>
          <el-form-item
            label="申込可能期間"
            prop="applicationRange"
            class="c-adminEventEdit__textAndForm"
          >
            <el-date-picker
              v-model="doc.applicationRange"
              type="datetimerange"
              range-separator="〜"
              start-placeholder="開始日"
              end-placeholder="終了日"
            >
            </el-date-picker>
          </el-form-item>
          <el-form-item label="ターゲット" class="c-adminEventEdit__checkboxs">
            <div class="group c-adminEventEdit__checkboxs__category">
              <el-checkbox
                v-model="item.checked"
                v-for="(item, index) in targets"
                :key="`targets-${index}`"
                :style="{
                  display: index > targets.length - 3 ? 'none' : 'flex',
                }"
                >{{ item.label }}</el-checkbox
              >
            </div>
            <div class="group c-adminEventEdit__checkboxs__category">
              <el-checkbox v-model="targets[targets.length - 2].checked"
                >賃借人も含める</el-checkbox
              >
              <el-checkbox v-model="targets[targets.length - 1].checked"
                >管理員も含める</el-checkbox
              >
            </div>
            <!-- <el-checkbox v-model="information.is_individual">個別</el-checkbox> -->
          </el-form-item>
        </el-form>
        <el-card
          class="box-card c-adminEventEdit__card"
          v-for="(item, index) in doc.schedules"
          :key="`sch_${index}`"
        >
          <div slot="header">
            <span style="font-size: 14px">イベント実施日の枠設定</span>
            <el-button
              style="float: right; padding: 3px 0; color: red"
              type="text"
              v-show="index != 0"
              @click="onDeleteSchedule(index)"
              >削除</el-button
            >
            <el-button
              style="float: right; padding: 3px 0"
              type="text"
              @click="onAddSchedule(index)"
              >コピー</el-button
            >
          </div>
          <el-form :model="doc">
            <el-form-item label="イベント実施日" prop="value1">
              <el-date-picker
                v-model="item.date"
                type="date"
                placeholder="イベント実施日"
              >
              </el-date-picker>
            </el-form-item>
            <el-form-item
              :label="`コマ${index2 + 1}`"
              v-for="(item2, index2) in item.komas"
              :key="`koma_${index}_${index2}`"
            >
              <div class="c-adminEventEdit__inputKomaWrap">
                <div class="c-adminEventEdit__inputKoma">
                  <el-time-select
                    style="width: 150px"
                    placeholder="開始時間"
                    v-model="item2.start"
                    :picker-options="{
                      start: '08:00',
                      step: '00:05',
                      end: '20:00',
                    }"
                  >
                  </el-time-select>
                  〜
                  <el-time-select
                    style="width: 150px"
                    placeholder="終了時間"
                    v-model="item2.end"
                    :picker-options="{
                      start: '08:00',
                      step: '00:05',
                      end: '21:00',
                      minTime: item2.start,
                    }"
                  >
                  </el-time-select>
                </div>
                <div class="c-adminEventEdit__inputKomaDeleteButton">
                  &ensp;枠数:
                  <el-input-number
                    v-model="item2.capacity"
                    :min="1"
                    :max="100"
                    placeholder="枠数"
                  ></el-input-number>
                  <el-checkbox v-model="item2.invisible">隠</el-checkbox>
                  <el-checkbox v-model="item2.is_absent">欠席</el-checkbox>
                  <div class="c-adminEventEdit__deleteButtonWrap">
                    <el-button
                      type="danger"
                      @click="onDeleteKoma(index, index2)"
                      v-show="index2 != 0"
                      >削除</el-button
                    >
                  </div>
                </div>
              </div>
              <div>
                <el-input
                  type="textarea"
                  placeholder="申し込みできない部屋番号をカンマ区切りで入力"
                  v-model="item2.excludedRooms"
                />
              </div>
              <el-form v-if="item2.is_absent" label_width="120px">
                <el-form-item label="タイトル">
                  <el-input
                    type="input"
                    placeholder="タイトル"
                    v-model="item2.absent_title"
                  />
                </el-form-item>
                <el-form-item label="ユーザ向けコピー">
                  <el-input
                    type="input"
                    placeholder="ユーザ向けコピー"
                    v-model="item2.absent_copy"
                  />
                </el-form-item>
                <el-form-item label="予約時メール挿入文">
                  <el-input
                    type="input"
                    placeholder="予約時メール挿入文"
                    v-model="item2.absent_mail_text"
                  />
                </el-form-item>
              </el-form>
            </el-form-item>
            <el-form-item>
              <el-button
                type="primary"
                @click="onAddKoma(index)"
                icon="el-icon-circle-plus"
                >コマ追加</el-button
              >
            </el-form-item>
          </el-form>
        </el-card>
        <div class="c-adminEventEdit__addEventButton">
          <el-form>
            <el-form-item>
              <el-button
                type="primary"
                @click="onAddSchedule()"
                icon="el-icon-circle-plus"
                >イベント実施日追加</el-button
              >
            </el-form-item>
          </el-form>
        </div>
        <el-divider></el-divider>
        <el-form ref="form_target3" :model="doc" :rules="docRules">
          <el-form-item label="キャンセル期限" prop="cancelDeadline">
            <el-date-picker
              v-model="doc.cancelDeadline"
              type="datetime"
              format="yyyy-MM-dd HH:mm"
              placeholder="キャンセル期限"
            >
            </el-date-picker>
          </el-form-item>
          <el-form-item label="残り枠表示"
            ><el-switch
              v-model="doc.visibleRemaining"
              active-color="#13ce66"
              inactive-color="#ff4949"
              active-text="する"
              inactive-text="しない"
            >
            </el-switch>
          </el-form-item>
          <el-divider></el-divider>
          <div class="c-adminEventEdit__checkInButtonsWrap">
            <el-form-item>
              <el-button type="primary" @click="preSubmit"
                >この内容で登録</el-button
              >
              <el-button @click="$router.back()">キャンセル</el-button>
            </el-form-item>
          </div>
        </el-form>
      </section>
    </el-col>
  </div>
</template>

<script>
import store from "../../../store";
const clonedeep = require("lodash/cloneDeep");
import PreviewService from "../../../services/preview.service";
import PageTitle from "@/components/PageTitle.vue";
export default {
  components: {
    PageTitle,
  },
  data() {
    return {
      value1: "",
      defaultKoma: {
        start: "",
        end: "",
        capacity: 4,
        invisible: false,
        excludedRooms: "",
      },
      defaultSchedule: {
        date: "",
        komas: [
          {
            start: "",
            end: "",
            capacity: 4,
            invisible: false,
            excludedRooms: "",
          },
        ],
      },
      doc: {
        title: "",
        publishRange: [],
        applicationRange: [],
        targets: [
          "OwnedResident",
          "OwnedNonResident",
          "Chairman",
          "Director",
          "Secretary",
        ],
        schedules: [
          {
            date: "",
            komas: [
              {
                start: "",
                end: "",
                capacity: 4,
                invisible: false,
                excludedRooms: "",
                is_absent: false,
                absent_title: "",
                absent_copy: "",
                absent_mail_text: "",
              },
            ],
          }, //{date:日付,{range:[start,end],capacity:定員}}
        ],
        cancelDay: 1,
        cancelDeadline: null,
        visibleRemaining: true,
        mansion: null,
      },
      docRules: {
        title: {
          required: true,
          message: "タイトルを入力してください",
          trigger: "blur",
        },
        publishRange: {
          required: true,
          message: "公開期間を入力してください",
          trigger: "blur",
        },
        applicationRange: {
          required: true,
          message: "申込期間を入力してください",
          trigger: "blur",
        },
        targets: {},
        schedules: {},
        cancelDay: {},
        cancelDeadline: {
          required: true,
          message: "キャンセル期限を入力してください",
          trigger: "blur",
        },
        visibleRemaining: {},
        mansion: {},
      },
      targets: [
        {
          value: "OwnedResident",
          label: "住居オーナー（区分所有者）",
          checked: false,
        },
        {
          value: "OwnedNonResident",
          label: "外部オーナー（区分所有者）",
          checked: false,
        },
        { value: "Chairman", label: "理事長（区分所有者）", checked: false },
        { value: "Director", label: "理事（区分所有者）", checked: false },
        { value: "Secretary", label: "監事（区分所有者）", checked: false },
        { value: "RentResident", label: "賃借人", checked: false },
        { value: "Manager", label: "管理員", checked: false },
        // { value: "ExternalParty", label: "外部関係者", checked: false },
      ],
    };
  },
  beforeRouteEnter(to, from, next) {
    const currentUser = store.state.auth.user;
    console.log(currentUser);
    if (
      currentUser &&
      !currentUser.permissions.includes("Admin") &&
      !currentUser.permissions.includes("EventAdmin")
    ) {
      console.log(":401");
      next({
        name: "notfound404",
        params: { mc_code: this.currentUser.mansion._id },
      });
    } else {
      next();
    }
  },
  // async created() {
  //   console.log("%c++++created", "color:orange");
  //   console.log(this.$route.params.id);
  //   if (this.$route.params.id) {
  //     const res = await PreviewService.findByID(this.$route.params.id);
  //     this.doc = res.data;
  //   }
  //   console.log(this.doc);
  // },
  async mounted() {
    console.log("%c++++mounted", "color:orange");
    console.log(this.$route.params.id);
    if (this.$route.params.id) {
      const res = await PreviewService.findByID(this.$route.params.id);
      this.doc = res.data;
    }
    console.log(this.doc);
    this.updateTargets(this.doc.targets);
  },
  watch: {
    rooms: function(val) {
      this.form.rooms = val.split(",");
    },
    targets: {
      // eslint-disable-next-line
      handler: function (val, oldVal) {
        console.log("someObj changed");
        const data = [];
        this.targets.forEach(element => {
          if (element.checked) {
            data.push(element.value);
          }
        });
        console.log(data);
        this.doc.targets = data;
      },
      deep: true,
    },
  },
  methods: {
    async preSubmit() {
      console.log("preSubmit");
      try {
        await this.$refs["form_target"].validate();
        await this.$refs["form_target3"].validate();
        this.onSubmit();
      } catch (error) {
        console.log(error);
      }
    },
    async onSubmit() {
      console.log("onSubmit");
      this.doc.mansion = this.currentUser.mansion.id;
      console.log(this.doc);
      try {
        let res;
        if (this.$route.params.id) {
          console.log("update");
          res = await PreviewService.update(this.doc);
        } else {
          console.log("create");
          res = await PreviewService.create(this.doc);
        }
        if (res.response) {
          console.log("+++ error");
          console.log(res.response);
          console.log(res.response.status);
          console.log(res.response.data);
          this.$message.error(res.response.data);
        } else {
          console.log("+++ successs");
          console.log(res);

          this.$message.success("登録しました");
          // this.$router.go(-1);
          this.$router.push({
            name: "admin-event",
          });
        }
      } catch (error) {
        console.log(error.message);
        this.$message.error("登録できませんでした");
      }
    },
    onAddKoma(index) {
      const prev = this.doc.schedules[index].komas[
        this.doc.schedules[index].komas.length - 1
      ];
      const newKoma = clonedeep(this.defaultKoma);
      console.log(prev);
      if (prev.end != "") {
        newKoma.start = prev.end;
      }
      this.doc.schedules[index].komas.push(newKoma);
    },
    onDeleteKoma(index, index2) {
      if (confirm("削除しても良いですか？")) {
        this.doc.schedules[index].komas.splice(index2, 1);
      }
    },
    onAddSchedule(copyIndex) {
      console.log(`onAddSchedule=${copyIndex}`);
      if (copyIndex != undefined) {
        console.log("copy");
        const newschedule = clonedeep(this.doc.schedules[copyIndex]);
        this.doc.schedules.push(newschedule);
      } else {
        console.log("create");
        const newschedule = clonedeep(this.defaultSchedule);
        this.doc.schedules.push(newschedule);
      }
    },
    onDeleteSchedule(index) {
      if (confirm("削除しても良いですか？")) {
        this.doc.schedules.splice(index, 1);
      }
    },
    updateTargets(array) {
      for (let index = 0; index < array.length; index++) {
        const element = array[index];
        const obj = this.targets.find(obj => obj.value == element);
        obj.checked = true;
      }
    },
  },
};
</script>

<style>
.box-card {
  margin-bottom: 20px;
}
</style>
